import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.04259 20.5387L13.0638 13.1137C13.6454 12.4986 13.6454 11.5014 13.0638 10.8863L6.04259 3.46133C5.46094 2.84622 4.51789 2.84622 3.93624 3.46133C3.35459 4.07643 3.35459 5.0737 3.93624 5.68881L9.90423 12L3.93624 18.3112C3.35459 18.9263 3.35459 19.9236 3.93624 20.5387C4.51789 21.1538 5.46094 21.1538 6.04259 20.5387ZM13.0426 20.5387L20.0638 13.1137C20.6454 12.4986 20.6454 11.5014 20.0638 10.8863L13.0426 3.46133C12.4609 2.84622 11.5179 2.84622 10.9362 3.46133C10.3546 4.07643 10.3546 5.0737 10.9362 5.68881L16.9042 12L10.9362 18.3112C10.3546 18.9263 10.3546 19.9236 10.9362 20.5387C11.5179 21.1538 12.4609 21.1538 13.0426 20.5387Z"
      fill={fill}
    />
    <mask
      id="mask0_0_52386"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="18"
      height="18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.04259 20.5387L13.0638 13.1137C13.6454 12.4986 13.6454 11.5014 13.0638 10.8863L6.04259 3.46133C5.46094 2.84622 4.51789 2.84622 3.93624 3.46133C3.35459 4.07643 3.35459 5.0737 3.93624 5.68881L9.90423 12L3.93624 18.3112C3.35459 18.9263 3.35459 19.9236 3.93624 20.5387C4.51789 21.1538 5.46094 21.1538 6.04259 20.5387ZM13.0426 20.5387L20.0638 13.1137C20.6454 12.4986 20.6454 11.5014 20.0638 10.8863L13.0426 3.46133C12.4609 2.84622 11.5179 2.84622 10.9362 3.46133C10.3546 4.07643 10.3546 5.0737 10.9362 5.68881L16.9042 12L10.9362 18.3112C10.3546 18.9263 10.3546 19.9236 10.9362 20.5387C11.5179 21.1538 12.4609 21.1538 13.0426 20.5387Z"
        fill="transparent"
      />
    </mask>
    <g mask="url(#mask0_0_52386)">
      <rect x="-28" y="-30" width="80" height="80" fill={fill} />
    </g>
  </>
);

export default Icon;
